// extracted by mini-css-extract-plugin
export default {"itemContainer":"ModuleSettings_itemContainer__BZgXX","companyLogo":"ModuleSettings_companyLogo__1238g"};